import React from 'react';
import PropTypes from 'prop-types';

import RichText from 'dpl/prismic/components/RichText';
import { getArticlePath } from 'dpl/prismic/utils';
import { StructuredTextPropTypes } from 'dpl/prismic/utils/customPropTypes';

import { ARTICLE_CONTENT_COL_CLASSES } from '../utils/constants';

export default function RelatedArticlesList({ sliceData }) {
  const articles = sliceData.items
    .map(i => {
      if (i.article.data) {
        return i.article;
      }
      return null;
    })
    .filter(Boolean);

  return (
    <div className="PrismicRelatedArticlesList container">
      <div className="row">
        <div className={ARTICLE_CONTENT_COL_CLASSES}>
          <p className="mb3 fw-medium">Related</p>
          <ul className="PrismicRelatedArticlesList__list ml9">
            {articles.map((article, idx) => (
              <li
                className="mt2 fw-medium"
                key={idx}
                data-test-id="RelatedArticleListItem"
              >
                <a className="link--primary" href={getArticlePath(article)}>
                  {RichText.asText(article.data.title)}
                </a>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  );
}

RelatedArticlesList.propTypes = {
  sliceData: PropTypes.shape({
    items: PropTypes.arrayOf(
      PropTypes.shape({
        article: PropTypes.shape({
          data: PropTypes.shape({
            title: StructuredTextPropTypes
          })
        })
      })
    ).isRequired
  }).isRequired
};
